/*
 * Jira Ticket:
 * Created Date: Mon, 20th Apr 2020, 18:01:49 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import gql from 'graphql-tag';
import uploadFile from './UPLOAD_FILE';

export const CreateTowerTypeMutation = gql`
  mutation CreateTowerType(
    $name: String!
    $qualificationIds: CommaSeparatedIntegerList!
    $status: TowerTypeStatus!
    $questions: [TowerTypeQuestionInput!]!
  ) {
    data: createTowerType(
      name: $name
      qualificationIds: $qualificationIds
      status: $status
      questions: $questions
    ) {
      id
      name
      questionCount
      questions {
        id
        question
        image {
          id
          url
        }
      }
      qualificationIds
      updatedAt
      status
    }
  }
`;

export default async ({ client, params }) => {
  try {
    if (params.data.questions) {
      const uploadRequest = await uploadFile({
        client,
        questions: params.data.questions,
      });
      for (let i = 0; i < params.data.questions.length; i++) {
        params.data.questions[i].imageId = uploadRequest.data.data.files[i].id;
        delete params.data.questions[i].image;
      }
    }
    if (!params.data.qualificationIds) params.data.qualificationIds = '';
    return client.mutate({
      mutation: CreateTowerTypeMutation,
      variables: {
        ...params.data,
      },
    });
  } catch (e) {
    if (e.graphQLErrors && e.graphQLErrors.length) {
      const [error] = e.graphQLErrors;
      const message = error.message;
      throw new Error(message);
    }
    throw e;
  }
};
